import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { toast } from 'react-hot-toast';
import { getBlogPosts, createBlogPost, updateBlogPost, deleteBlogPost } from '../../services/admin/blogService';

export function useBlogPosts() {
  const [posts, setPosts] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadPosts = async () => {
    try {
      const data = await getBlogPosts();
      setPosts(data);
    } catch (error) {
      console.error('Error loading blog posts:', error);
      toast.error('Failed to load blog posts');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPosts();
  }, []);

  const handleCreatePost = async (postData: any) => {
    try {
      const newPost = await createBlogPost(postData);
      await loadPosts();
      return newPost;
    } catch (error) {
      console.error('Error creating post:', error);
      throw error;
    }
  };

  const handleUpdatePost = async (postId: string, postData: any) => {
    try {
      const updatedPost = await updateBlogPost(postId, postData);
      await loadPosts();
      return updatedPost;
    } catch (error) {
      console.error('Error updating post:', error);
      throw error;
    }
  };

  const handleDeletePost = async (postId: string) => {
    try {
      await deleteBlogPost(postId);
      await loadPosts();
    } catch (error) {
      console.error('Error deleting post:', error);
      throw error;
    }
  };

  return {
    posts,
    isLoading,
    createPost: handleCreatePost,
    updatePost: handleUpdatePost,
    deletePost: handleDeletePost,
    refreshPosts: loadPosts
  };
}